// extracted by mini-css-extract-plugin
export default {"section":"phonebook_section__wcWYi"};